import React, { Component } from 'react';
import cns from 'classnames';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';

class UserCollectionCardLoading extends Component {
    static propTypes = {
        className: PropTypes.string
    };

    render() {
        const { className = 'col-12 col-sm-6' } = this.props;
        return (
            <div className={cns('user-collection-card', 'loading-card', className)}>
                <Row className={'collection-container'}>
                    <div className={'collection-image loading col-12'} />
                </Row>
                <Row className={'collection-container'}>
                    <div className={'col-7 asset-details'}>
                        <div className={'asset-title loading'} />
                        <div className={cns('asset-subtitle-container')}>
                            <small className={'asset-subtitle loading'} />
                        </div>
                        <div className={'asset-metadata-container'}>
                            <div className={'completeness-data loading'} />
                        </div>
                    </div>
                </Row>
            </div>
        );
    }
}

export default UserCollectionCardLoading;
